import {
  action,
  observable,
  makeObservable,
  makeAutoObservable,
  runInAction,
  autorun,
  toJS,
} from 'mobx'
import { ViewForm } from '../../../../services/api'
import { message } from 'antd'
import { produce } from 'immer'
import { observer } from 'mobx-react-lite'
import { getUser, getUsernameUser } from '../../../../utils/sessionManagement'
import { useParams } from 'react-router-dom'
import { nanoid } from 'nanoid'
import { useMemo, useRef, useEffect } from 'react'
import React from 'react'

class ViewFormStore {
  formDataAPI = []
  formInformations = []
  formDesign = []

  fields = []
  buttonDesign = []

  errorCode = null

  isPermissionChecked = false
  hasPermission = null

  modalVisibilityUpdateOpen = false
  modalDuplicateResponseOpen = false
  modalAddNewResponseOpen = false

  constructor(url_code) {
    makeAutoObservable(this)
    this.url_code = url_code
  }

  async initialisationGET(isEditing, idResponse) {
    try {
      let formDetailsArray

      // Vérification de la valeur de isEditing
      if (isEditing !== undefined && isEditing === true) {
        if (idResponse !== undefined && idResponse !== '') {
          formDetailsArray = await ViewForm(
            this.url_code,
            isEditing,
            idResponse
          )
        }
      } else {
        // Sinon, faites l'appel API normal
        formDetailsArray = await ViewForm(this.url_code)
      }

      runInAction(() => {
        this.formDataAPI = formDetailsArray
        this.formInformations = this.formDataAPI.form
        this.formDesign = this.formDataAPI.form.design
        this.buttonDesign = this.formDataAPI.form.design_button
        this.fields = this.formDataAPI.fields.map((field) => {
          return {
            ...field,
            type: field.field_type,
          }
        })

        console.log(toJS(this.fields))

        this.hasPermission = true
        this.isPermissionChecked = true
      })
    } catch (error) {
      runInAction(() => {
        this.hasPermission = false
        this.isPermissionChecked = true
        this.errorCode = error.response?.data.code
      })
      console.log(
        'Une erreur est survenue lors de la récupération des détails du formulaire : ',
        error
      )
    }
  }

  toggleModalVisibilityUpdateOpen = action((bool) => {
    this.modalVisibilityUpdateOpen = bool
  })

  toggleModalDuplicateResponseOpen = action((bool) => {
    this.modalDuplicateResponseOpen = bool
  })

  toggleModalAddNewResponseOpen = action((bool) => {
    this.modalAddNewResponseOpen = bool
  })
}

const ViewFormContext = React.createContext()

const ViewFormProvider = observer(({ children }) => {
  const { url_code } = useParams()
  const store = useMemo(() => new ViewFormStore(url_code), [url_code])
  // Ici, utilisez l'API useEffect pour exécuter des actions d'initialisation et d'autres choses qui dépendent des changements de l'état du store
  // Le store est maintenant disponible pour les enfants
  return (
    <ViewFormContext.Provider value={store}>
      {children}
    </ViewFormContext.Provider>
  )
})

export { ViewFormContext, ViewFormProvider }
